import { IStore } from 'src/interfaces/store';
import { StoreExtractor } from './types';

export class StoreFullExtractor implements StoreExtractor<IStore> {
    extract(store: IStore): IStore {
        return store;
    }

    shouldInclude(store: IStore, makeId?: string): boolean {
        return store.make?._id === makeId;
    }
}
